import { styled as t } from "styled-components";
import { Colors as r } from "../../../../styles/colors/index.js";
import { Theme as i } from "../../../../styles/themes/index.js";
import { SmallLight as o } from "../../../../styles/typography/index.js";
const g = t.div`
  ${o}
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  height: 24px;
  padding: 4px 8px;
  gap: 4px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background: rgb(${r.Graphite});
  color: rgb(${r.White});

  &[data-visible='false'] {
    display: none;
  }

  svg {
    fill: rgb(${i.colors.Brand});
    height: 14px;
    width: 14px;
  }
`;
export {
  g as Tag
};
